import {
   applyMemberEvents,
   deleteChannel,
   deleteRecentChannelItem,
   deleteMultipleRecentChannels,
   getUserRole,
   leaveMemberFromChannel,
   resetActiveLeftPane,
   resetPanels,
   retActiveConversationChannel,
   setChannelInfo,
   updateChannelStatus,
   updateRoleId,
   removeInvitationsByUserId,
} from '../../../Slice';
import Store from '../../../Store';
import { getLocalUserDetails } from '../commonActions';

export const handleLeaveMemberInChannel = data => {
   try {
      Store.dispatch(leaveMemberFromChannel(data));
      const channelId = data?.channel?.channelId;
      const member = data?.member;
      if (member) {
         Store.dispatch(applyMemberEvents({ channelId, memberEvents: [{ type: 'LEAVE', member }] }));
      }
      const memberId = member?.userId;
      if (memberId) {
         Store.dispatch(
            removeInvitationsByUserId({
               channelId,
               userId: memberId,
            }),
         );
      }
   } catch (error) {
   }
};

export const handleDeleteChannel = data => {
   try {
      const { channelId, initiatedBy } = data;
      const { userId } = getLocalUserDetails();
      const userRole = getUserRole(channelId);
      const isLocalUserAdmin = userId === initiatedBy && [1, 2].includes(userRole);
      if (isLocalUserAdmin) {
         Store.dispatch(deleteChannel({ channelId }));
         Store.dispatch(retActiveConversationChannel());
         Store.dispatch(resetPanels());
         Store.dispatch(resetActiveLeftPane());
         Store.dispatch(deleteRecentChannelItem({ channelId }));
      } else {
         Store.dispatch(updateChannelStatus(data.channel));
      }
   } catch (error) {
   }
};

export const updateChannelActiveStatus = async data => {
   try {
      Store.dispatch(updateChannelStatus(data));
   } catch (error) {
   }
};

export const handleChannelMemberRemoved = data => {
   try {
      const channelId = data?.channelId;
      const participants = data?.removedParticipants;

      if (!channelId || !Array.isArray(participants) || participants.length === 0) return;

      // You may want to guard for local user ID here if needed
      const normalized = participants.map(p => ({
         ...p,
         userId: p.userId || p.user_id,
         channelId,
         status: 0,
      }));

      normalized.forEach(member => {
         handleLeaveMemberInChannel({
            channel: data.channel,
            member,
         });
      });
   } catch (error) {
      console.error('Failed to handle CHANNEL_MEMBER_REMOVED:', error);
   }
};

export const handleRoleChangedEvent = data => {
   try {
      const {
         updatedMember,
         channel,
         updatedMember: { userId, roleId },
         channelId,
      } = data || {};
      if (!updatedMember || !channelId) return;

      const memberEvents = [
         {
            type: 'ROLE_CHANGED',
            member: {
               ...updatedMember,
               userId,
               roleId,
            },
         },
      ];
      Store.dispatch(setChannelInfo(channel));
      Store.dispatch(updateRoleId({ channelId, userId, roleId }));
      Store.dispatch(applyMemberEvents({ channelId, memberEvents }));
      const memberId = updatedMember?.userId;
      if(memberId && updatedMember.roleId === 3){
         Store.dispatch(
            removeInvitationsByUserId({
               channelId,
               userId: memberId,
            }),
         );
      }
   } catch (error) {
      console.error('Failed to handle ROLE_CHANGED event:', error);
   }
};

export const handleChannelRemoved = data => {
   try {
      const { channelIds, initiatedBy } = data;

      if (!Array.isArray(channelIds) || channelIds.length === 0) {
         console.warn('Invalid channelIds provided for CHANNEL_REMOVED event:', channelIds);
         return;
      }

      // Remove channels from recent list
      Store.dispatch(deleteMultipleRecentChannels({ channelIds }));

      // If currently active channel is in the removed list, reset active conversation
      const state = Store.getState();
      const activeChannelId = state.channelNavData.activeConversationChannel?.channelId;
      if (activeChannelId && channelIds.includes(activeChannelId)) {
         Store.dispatch(retActiveConversationChannel());
         Store.dispatch(resetPanels());
         Store.dispatch(resetActiveLeftPane());
      }

   } catch (error) {
      console.error('Failed to handle CHANNEL_REMOVED event:', error);
   }
};
